var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 11.5C19.0008 11.8003 18.9256 12.0958 18.7818 12.3575C18.638 12.6193 18.4306 12.8385 18.1796 12.9938L2.62551 22.7396C2.36328 22.9041 2.06293 22.9939 1.75549 22.9997C1.44804 23.0055 1.14465 22.9272 0.876652 22.7728C0.611202 22.6208 0.390075 22.3991 0.236011 22.1305C0.0819461 21.8619 0.000504575 21.5562 6.10352e-05 21.2447V1.75532C0.000504575 1.44383 0.0819461 1.13807 0.236011 0.869502C0.390075 0.600932 0.611202 0.37924 0.876652 0.227224C1.14465 0.0728088 1.44804 -0.00552806 1.75549 0.000303349C2.06293 0.00613476 2.36328 0.0959232 2.62551 0.260395L18.1796 10.0062C18.4306 10.1615 18.638 10.3807 18.7818 10.6425C18.9256 10.9042 19.0008 11.1997 19.0001 11.5Z",
    fill: "#37A0F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBlue);
export default __webpack_public_path__ + "static/media/play_blue.8829e24e62dc2ab57783d8becdd57cee.svg";
export { ForwardRef as ReactComponent };